import { WOW } from 'wowjs';
export default {
  name: 'CompanyIntroduction',
  data() {
    return {
      wow: null
    };
  },
  mounted() {
    this.wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    this.wow.init();
    this.syncWow();
  },
  updated() {
    this.syncWow();
  },
  methods: {
    syncWow() {
      if (this.wow) {
        this.wow.sync();
      }
    }
  }
};